import { render, staticRenderFns } from "./common_ReleasePage.vue?vue&type=template&id=839ede6e&"
import script from "./common_ReleasePage.vue?vue&type=script&lang=js&"
export * from "./common_ReleasePage.vue?vue&type=script&lang=js&"
import style0 from "./common_ReleasePage.vue?vue&type=style&index=0&id=839ede6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports